var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightClickPanIcon = function SvgRightClickPanIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.025,
    d: "M11.584 10.66v.013h-1.74v-.013q0-.776.491-1.369a2.1 2.1 0 0 1 1.234-.743l.015-.003zm-1.74.857v-.012h4.311v1.726q0 .895-.63 1.525t-1.525.63c-.895 0-1.105-.21-1.525-.63q-.63-.63-.63-1.525zM12 16.22q1.238 0 2.113-.875a2.88 2.88 0 0 0 .875-2.113V10.66q0-1.238-.875-2.113A2.88 2.88 0 0 0 12 7.672q-1.238 0-2.113.875a2.88 2.88 0 0 0-.875 2.113v2.571q0 1.239.875 2.113a2.88 2.88 0 0 0 2.113.875Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.051 11.632a.33.33 0 0 0 0 .467l2.1 2.1a.33.33 0 1 0 .467-.467l-1.867-1.867L4.618 10a.33.33 0 0 0-.467-.467zm4.849-.097H2.284v.66H6.9zm14.949.097a.33.33 0 0 1 0 .467l-2.1 2.1a.33.33 0 1 1-.467-.467l1.867-1.867L19.282 10a.33.33 0 0 1 .467-.467zM17 11.535h4.615v.66H17zM12.233 21.85a.33.33 0 0 1-.466 0l-2.1-2.1a.33.33 0 0 1 .466-.467L12 21.149l1.867-1.867a.33.33 0 0 1 .466 0 .33.33 0 0 1 0 .467zM12.33 17v4.615h-.66V17zm-.097-14.983a.33.33 0 0 0-.466 0l-2.1 2.1a.33.33 0 0 0 .466.466L12 2.718l1.867 1.866a.33.33 0 1 0 .466-.466zm.097 4.848V2.25h-.66v4.615z"
  }))));
};
export default SvgRightClickPanIcon;